import { render, staticRenderFns } from "./paster.vue?vue&type=template&id=540af7c4&scoped=true&"
import script from "./paster.vue?vue&type=script&lang=js&"
export * from "./paster.vue?vue&type=script&lang=js&"
import style0 from "./paster.vue?vue&type=style&index=0&id=540af7c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540af7c4",
  null
  
)

export default component.exports